/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { AdminAuditGetAdminAuditParams, PagedResultOfAuditEntryDto } from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Paginated audit trail.
 */
export const adminAuditGetAdminAudit = (
  params?: AdminAuditGetAdminAuditParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<PagedResultOfAuditEntryDto>(
    { url: `/admin/audit`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminAuditGetAdminAuditQueryKey = (params?: AdminAuditGetAdminAuditParams) => {
  return [`/admin/audit`, ...(params ? [params] : [])] as const;
};

export const getAdminAuditGetAdminAuditQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
  TError = unknown,
>(
  params?: AdminAuditGetAdminAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAuditGetAdminAuditQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>> = ({
    signal,
  }) => adminAuditGetAdminAudit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminAuditGetAdminAuditQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAuditGetAdminAudit>>
>;
export type AdminAuditGetAdminAuditQueryError = unknown;

export function useAdminAuditGetAdminAudit<
  TData = Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
  TError = unknown,
>(
  params: undefined | AdminAuditGetAdminAuditParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
          TError,
          Awaited<ReturnType<typeof adminAuditGetAdminAudit>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditGetAdminAudit<
  TData = Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
  TError = unknown,
>(
  params?: AdminAuditGetAdminAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
          TError,
          Awaited<ReturnType<typeof adminAuditGetAdminAudit>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditGetAdminAudit<
  TData = Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
  TError = unknown,
>(
  params?: AdminAuditGetAdminAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Paginated audit trail.
 */

export function useAdminAuditGetAdminAudit<
  TData = Awaited<ReturnType<typeof adminAuditGetAdminAudit>>,
  TError = unknown,
>(
  params?: AdminAuditGetAdminAuditParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminAuditGetAdminAudit>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminAuditGetAdminAuditQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
